import { colorObj } from "../../../../../constants/colorObj";
export var onGetColoredState = function (state, value, maxLength) {
    var _a;
    var isNotUpdatedStyles = (_a = ['annotation', 'block_with_title']) === null || _a === void 0 ? void 0 : _a.includes(state.style);
    if (isNotUpdatedStyles) {
        return {
            text: value.substring(0, maxLength),
            style: state.style
        };
    }
    else {
        return {
            text: value.substring(0, 2400),
            color: colorObj.white,
            isTitleOpened: false,
            fontColor: colorObj.fonts.white,
            isTextTooBig: true,
            isColorChoose: false,
            prevColorStatus: state.colorName,
            colorName: 'white',
            style: 'normal'
        };
    }
};
//# sourceMappingURL=onGetColoredState.js.mapimport { colorObj } from "../../../../../constants/colorObj";
export var onGetColoredState = function (state, value, maxLength) {
    var _a;
    var isNotUpdatedStyles = (_a = ['annotation', 'block_with_title']) === null || _a === void 0 ? void 0 : _a.includes(state.style);
    if (isNotUpdatedStyles) {
        return {
            text: value.substring(0, maxLength),
            style: state.style
        };
    }
    else {
        return {
            text: value.substring(0, 2400),
            color: colorObj.white,
            isTitleOpened: false,
            fontColor: colorObj.fonts.white,
            isTextTooBig: true,
            isColorChoose: false,
            prevColorStatus: state.colorName,
            colorName: 'white',
            style: 'normal'
        };
    }
};
//# sourceMappingURL=onGetColoredState.js.map